import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { NEVER, Observable } from 'rxjs';
import { AuthService } from '@schoolbelle/api/auth';
import { map, switchMap } from 'rxjs/operators';
import { GroupService } from '@schoolbelle/api/group';
import { BoardService } from '@schoolbelle/api/board';
import { Letter, LetterService } from '@schoolbelle/api/letter';
import { ReadListModalService } from './read-list.service';

@Injectable({
  providedIn: 'root'
})
export class ReadListGuard implements CanActivate {
  constructor (
    private auth:AuthService,
    private group:GroupService,
    private board:BoardService,
    private letter:LetterService,
    private readListModalService:ReadListModalService,
    private router:Router,
  ) {

  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      const {group_id, board_type, letter_id} = next.params;
      return this.auth.fetchUser().pipe(
        switchMap(currentUser=>{
          if (!currentUser) {
            this.router.navigate(['/login'], {queryParams:next.queryParams ,queryParamsHandling:'merge'});
            return NEVER
          }
          return this.group.checkIn(Number(group_id))
        }),
        switchMap((currentGroup)=>{
          return this.board.checkIn(`${group_id}|${board_type}`)
        }),
        switchMap(()=>{
          return this.letter.get({letter_id:Number(letter_id)})

        }),
        switchMap((letter)=>{
          return this.readListModalService.prepare(letter as Letter & {letter_id:number})
        }),
        map(()=>true),
      )
  }
}
